import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
// import _ from 'lodash';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import GochiEventSettingConnectTableHead from '../../components/molecules/GochiEventSettingConnectTableHead';
import GochiEventSettingConnectTableBody from '../../components/molecules/GochiEventSettingConnectTableBody';
import ExPagination from '../../components/molecules/ExPagination';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import ConfirmDialog from '../../components/molecules/ConfirmDialog';
import { connectGochiEventSetting } from '../../actions/GochiEventSetting';
import { sendLogin } from '../../auth/Auth';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      events: state.gochiEvent.dataByMenu.list,
      totalCount: state.gochiEvent.dataByMenu.count,
      offset: state.gochiEvent.dataByMenu.offset,
      menuStatus: state.gochiEvent.dataByMenu.status
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          connectGochiEventSetting
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openConnect', 'updateOpenConnect', false),
  withState('openConnectModal', 'updateOpenConnectModal', false),
  withState('openDisconnect', 'updateOpenDisconnect', false),
  withState('openDisconnectProgress', 'updateOpenDisconnectProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isDeleteSuccess', 'updateIsDeleteSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),

  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('targetRowName', 'setTargetRowName', ''),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('page', 'setPage', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    page,
    selectedPage,
    handleChangePage,
    events,
    totalCount,
    offset,
    openDisconnect,
    updateOpenDisconnect,
    rowsPerPage,
    targetRowId,
    setTargetRowId,
    openConnect,
    updateOpenConnect,
    openDisconnectProgress,
    updateOpenDisconnectProgress,
    loading,
    updateLoading,
    isDeleteSuccess,
    updateIsDeleteSuccess,
    resultMessage,
    setResultMessage,
    order,
    orderBy,
    handleChangeRowsPerPage,
    handleRequestSort,
    targetRowName,
    setTargetRowName,
    gochiMenuId,
    menuStatus
  }) => {
    const connectOpenAction = event => {
      updateOpenConnect(true);
      setTargetRowId(event.gochiEventId);
      setTargetRowName(event.gochiEventName);
    };

    const disconnectOpenAction = event => {
      updateOpenDisconnect(true);
      setTargetRowId(event.gochiEventId);
      setTargetRowName(event.gochiEventName);
    };
    const cancelAction = () => updateOpenDisconnect(false);
    const cancelConnectAction = () => updateOpenConnect(false);
    const disconnectAction = async () => {
      updateLoading(true);
      updateOpenDisconnect(false);
      updateOpenDisconnectProgress(true);
      const disConnectEvent = await actions
        .connectGochiEventSetting(gochiMenuId, {
          gochiEventId: targetRowId,
          status: 0
        })
        .then(data => checkSession(data));
      if (disConnectEvent.type === 'CONNECT_GOCHI_EVENT_SETTING_SUCCESS') {
        updateIsDeleteSuccess(true);
        // handleChangePage(null, selectedPage, rowsPerPage);
        setResultMessage('解除しました。');
        updateLoading(false);
      } else {
        updateIsDeleteSuccess(false);
        setResultMessage('解除に失敗しました。もう一度やり直してください。');
        updateLoading(false);
      }
    };
    const connectAction = async () => {
      updateOpenConnect(false);
      updateLoading(true);
      updateOpenDisconnectProgress(true);
      const disConnectEvent = await actions
        .connectGochiEventSetting(gochiMenuId, {
          gochiEventId: targetRowId,
          status: 1
        })
        .then(data => checkSession(data));
      if (disConnectEvent.type === 'CONNECT_GOCHI_EVENT_SETTING_SUCCESS') {
        updateIsDeleteSuccess(true);
        // handleChangePage(null, selectedPage, rowsPerPage);
        setResultMessage('連携しました。');
        updateLoading(false);
      } else {
        updateIsDeleteSuccess(false);
        setResultMessage('連携に失敗しました。もう一度やり直してください。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isDeleteSuccess) {
        updateOpenDisconnect(false);
        updateOpenConnect(false);
        updateOpenDisconnectProgress(false);
        updateIsDeleteSuccess(false);
        handleChangePage(null, selectedPage, rowsPerPage);
      } else {
        updateOpenDisconnectProgress(false);
      }
    };

    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <GochiEventSettingConnectTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              // roles={roles}
            />
            <GochiEventSettingConnectTableBody
              events={events}
              connectAction={connectOpenAction}
              disconnectAction={disconnectOpenAction}
              order={order}
              orderBy={orderBy}
              menuStatus={menuStatus}
            />
          </Table>
        </div>
        <div>
          <ExPagination
            searchResults={events}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalCount={totalCount}
            offset={offset}
            selectedPage={selectedPage}
          />
        </div>
        <ConfirmDialog
          openConfirm={openDisconnect}
          cancelAction={cancelAction}
          updateOpenConfirm={updateOpenDisconnect}
          okAction={disconnectAction}
          targetRowId={targetRowId}
          message={`${targetRowName} の連携を解除しましょうか？`}
        />
        <ConfirmDialog
          openConfirm={openConnect}
          cancelAction={cancelConnectAction}
          updateOpenConfirm={updateOpenConnect}
          okAction={connectAction}
          targetRowId={targetRowId}
          message={`${targetRowName} に連携しましょうか？`}
        />
        <ProgressDialog
          openProgress={openDisconnectProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
